module.exports = __webpack_public_path__ + "static/media/icons.02a6a7d6.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icons.eot
// module id = 289
// module chunks = 0